import { createIconComponent } from '../../factory/create-icon-component';
export const NewZealandIcon = createIconComponent(
  'NewZealandIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10102_33829)">
      <path d="M23 5.00031H1V20.0001H23V5.00031Z" fill="#0052B4" />
      <path
        d="M19.274 11.522L19.4196 11.9803H19.8907L19.5095 12.2635L19.6551 12.7217L19.274 12.4385L18.8928 12.7217L19.0384 12.2635L18.6573 11.9803H19.1284L19.274 11.522Z"
        fill="#D80027"
      />
      <path
        d="M17.59 14.821L17.8084 15.5084H18.515L17.9433 15.9332L18.1617 16.6205L17.59 16.1957L17.0183 16.6205L17.2367 15.9332L16.665 15.5084H17.3716L17.59 14.821Z"
        fill="#D80027"
      />
      <path
        d="M17.6535 9.42261L17.8356 9.99546H18.4244L17.948 10.3494L18.1299 10.9222L17.6535 10.5681L17.1771 10.9222L17.3591 10.3494L16.8827 9.99546H17.4715L17.6535 9.42261Z"
        fill="#D80027"
      />
      <path
        d="M16.0331 11.5021L16.2515 12.1894H16.9582L16.3864 12.6142L16.6049 13.3015L16.0331 12.8767L15.4614 13.3015L15.6798 12.6142L15.1081 12.1894H15.8147L16.0331 11.5021Z"
        fill="#D80027"
      />
      <path
        d="M12.0002 5V6.34311L10.059 7.44558H12.0002V10.0541H9.46023L12.0002 11.4975V12.4997H10.8534L7.69589 10.7056V12.4997H5.3046V10.3651L1.54788 12.4997H1.00024V11.157L2.94106 10.0541H1.00024V7.44558H3.53983L1.00024 6.00272V5H2.14665L5.3046 6.79459V5H7.69589V7.1345L11.4527 5H12.0002Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.1875 5.00006H5.8125V8.04689H1V9.4531H5.8125V12.4999H7.1875V9.4531H12V8.04689H7.1875V5.00006Z"
        fill="#D80027"
      />
      <path
        d="M7.69598 10.0543L12.0003 12.4999V11.8083L8.91316 10.0543H7.69598Z"
        fill="#0052B4"
      />
      <path
        d="M7.69598 10.0543L12.0003 12.4999V11.8083L8.91316 10.0543H7.69598Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.69598 10.0543L12.0003 12.4999V11.8083L8.91316 10.0543H7.69598Z"
        fill="#D80027"
      />
      <path
        d="M4.08713 10.0543L1 11.8083V12.4999L5.30435 10.0543H4.08713Z"
        fill="#D80027"
      />
      <path
        d="M5.30435 7.44569L1 5.00006V5.69165L4.08718 7.44569H5.30435Z"
        fill="#0052B4"
      />
      <path
        d="M5.30435 7.44569L1 5.00006V5.69165L4.08718 7.44569H5.30435Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.30435 7.44569L1 5.00006V5.69165L4.08718 7.44569H5.30435Z"
        fill="#D80027"
      />
      <path
        d="M8.9132 7.44563L12.0003 5.69159V5L7.69598 7.44563H8.9132Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_10102_33829">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
